'use client'
import Container from '@/layouts/Container.layout';
import { FAQSection } from '@/utils/strapi/sections/FAQ';
import Accordion from '@/components/Accordion/Accordion'
import { RichTextRenderer } from '@/components/RichTextRenderer/RichTextRenderer';
import { BlocksContent } from '@strapi/blocks-react-renderer';
import React from 'react'

type FaqListItem = {
  question: string;
  answer: BlocksContent;
}

export const FaqSection = (props: FAQSection) => {
  const { title, description, faqs } = props;
  
  const faqList: Array<FaqListItem> = faqs?.categoria_faq?.preguntas_frecuentes?.slice(0, faqs?.max_entries)?.map((item) => ({
    question: item.question,
    answer: item.answer,
  })) || [];

  return (
    <section id='faq-section'>
      <Container>
        <h3 className='font-headings font-bold text-2xl text-surface-900 mb-6'>{title}</h3>
        <RichTextRenderer content={description!} />
        <div>
          {faqList?.map(({ question, answer }, index) => (
            <Accordion key={index}>
              {({ open }) => (
                <React.Fragment key={index}>
                  <Accordion.Button open={open} className='flex flex-row justify-between items-center'>
                    <p className='font-texts font-bold text-base text-surface-900'>{question}</p>
                    <span className={open ? 'rotate-180 transform delay-75 material-symbols-outlined text-surface-500' : 'material-symbols-outlined text-surface-500'} >expand_more</span>
                  </Accordion.Button>
                  <Accordion.Content>
                    {open ? <RichTextRenderer content={answer} /> : null}
                  </Accordion.Content>
                </React.Fragment>
              )
              }
            </Accordion>))}
        </div>

      </Container>
    </section>

  )
}

export default FaqSection;